import React from 'react';
import I18n from 'app/i18n';
import {fixed2int} from 'app/utils/fixed';
import LootInterface from 'app/interfaces/LootInterface';

const META_SEPARATOR = ' · ';

interface ShopItemMetaProps {
    loot?: LootInterface[] | null
    maxCalculatedPrice?: number | string | null
    gameName?: string | null
}

const ShopItemMeta = ({loot, maxCalculatedPrice, gameName}: ShopItemMetaProps): React.ReactElement | null => {
    if (!loot || loot.length === 0) {
        return null;
    }

    const parts = [];

    if (gameName) {
        parts.push(gameName);
    }

    parts.push(I18n.t('shop.lootbox_items_count', {count: loot.length}));
    const maxPrize = Number(maxCalculatedPrice);

    if (maxPrize > 0) {
        parts.push(I18n.t('shop.lootbox_max_prize', {amount: fixed2int(maxPrize)}));
    }

    return <p className="market__lootbox--meta">{parts.join(META_SEPARATOR)}</p>;
};

export default ShopItemMeta;
